import { FC, useState } from 'react';
import { Icon } from 'src/components';
import { UserPathBlob } from 'src/api/userPath/types';
import * as S from './styles';

export const BlobImage: FC<{
  blob: Pick<UserPathBlob, 'type' | 'iconUrl' | 'photoUrl'>;
  current?: boolean;
  iconOnly?: boolean;
}> = ({ blob, current, iconOnly }) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  // Current scenario cards show LwL video (or a vector placeholder while it loads).
  // Never paint the scenario photo/icon there — both flash and look wrong in the
  // square frame before the video replaces them.
  const url = iconOnly
    ? blob.iconUrl
    : current
      ? blob.type === 'scenario'
        ? null
        : blob.photoUrl || blob.iconUrl
      : blob.iconUrl || blob.photoUrl;
  const fallbackIcon = blob.type === 'scenario' ? 'communicateOutline' : 'openBook';

  if (!url || failedUrl === url) {
    return current ? (
      <S.CurrentFallback aria-hidden>
        <Icon name={fallbackIcon} />
      </S.CurrentFallback>
    ) : (
      <Icon name={fallbackIcon} />
    );
  }

  const Image = current ? S.CurrentImage : 'img';
  return (
    <Image
      src={url}
      alt=""
      loading={current ? 'eager' : 'lazy'}
      onError={() => setFailedUrl(url)}
    />
  );
};
